import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (typeof window !== "undefined") {
  const isPayPalRelated = (event) => {
    const message = event?.message || event?.error?.message || "";
    const filename = event?.filename || "";
    return message === "Script error." ||
      message.toLowerCase().includes("paypal") ||
      filename.toLowerCase().includes("paypal");
  };

  window.addEventListener("error", (event) => {
    if (isPayPalRelated(event)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
    return undefined;
  }, true);

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason || {};
    const message = reason?.message || String(reason);
    if (message.toLowerCase().includes("paypal") || message === "Script error.") {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
